// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 96 ? "vendors" : chunkId) + "-" + {"96":"3dd823885d576e773018","355":"f75ee10e86ade7adce15","486":"b4ca57a79c0dd0a0bb71","631":"f661bc7dbd7f2b635473","673":"4491b7b731e4660b72c4","836":"685943aa39d6367c44fa","898":"7f80ad140714777ba236","985":"be656b6afd39129e9e37"}[chunkId] + ".bundle.js";
};